export default "__VITE_ASSET__Cg3fkHzO__"